module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.432678b1.otf";